import { jsx as _jsx } from "react/jsx-runtime";
import { TypographyText } from '../_core';
import styles from '../typography.module.css';
const LEVEL_CLASS = {
    1: styles.h1,
    2: styles.h2,
    3: styles.h3,
    4: styles.h4,
    5: styles.h5,
    6: styles.h6,
};
/**
 * Semantic heading. Renders `<h1>`–`<h6>` matching the `level` prop.
 *
 * level=1, 2 → 24px serif (page title, major section)
 * level=3, 4 → 18px serif (card/modal title, sub-section)
 * level=5, 6 → 14px sans 600 (form-section heading, markdown h6)
 *
 * Opt-in `size="lg"` (level=1/2 only) renders 32px serif title-lg — the
 * dashboard / standalone-page hero-title tier.
 *
 * No `as` prop — the rendered element is always `h{level}` to enforce
 * semantic correctness. Use `<Display>` for hero-scale non-semantic headings.
 *
 * Do not override fontSize, fontFamily, lineHeight, fontWeight, or
 * letterSpacing via style prop.
 */
export function Heading({ level, size, children, style, ...rest }) {
    const tag = `h${level}`;
    const roleClassName = size === 'lg' && (level === 1 || level === 2)
        ? styles['h-lg']
        : LEVEL_CLASS[level];
    return (_jsx(TypographyText, { as: tag, roleClassName: roleClassName, style: style, ...rest, children: children }));
}
//# sourceMappingURL=Heading.js.map